<template>
    <div>
        morePage
        <div :class="{'isRed':isRed}">{{str}}</div>
        <el-button @click="changeColor()">点击我登录获取koken={{token}}</el-button>
        <el-button @click="changeStore()">点击我使用VueX 更新store</el-button>

        <div style="display: flex;">
            <div ref="echart"  class="chartBox">1234</div>
            <div ref="echart1" class="chartBox"></div>
            <div ref="echart2" class="chartBox"></div>
            <div ref="echart3" class="chartBox"></div>
        </div>
        <div v-for="n of msgList">
            {{n.title}}
        </div>

        <el-row>
            <el-col :span="8"><div class="grid-content bg-purple">1</div></el-col>
            <el-col :span="8"><div class="grid-content bg-purple-light">2</div></el-col>
            <el-col :span="8"><div class="grid-content bg-purple">3</div></el-col>
        </el-row>

    </div>

</template>

<script>
    import {ref,getCurrentInstance,onMounted} from 'vue'
    import * as echarts from 'echarts'

    export default {
        // name: "morePage"
        setup() {
            const str = ref('hello'); // 声明 str，初始值为 'hello'
            const isRed = ref(false); // 声明 str，初始值为 'hello'
            const msgList = ref([{title:'zzzzzz'}]); // 声明 str，初始值为 'hello'
            str.value = "我是张大海";
             const { ctx } = getCurrentInstance();

            const echart=ref(null);
            const echart1=ref(null);
            const echart2=ref(null);
            const echart3=ref(null);
            const token = ref(''); // 声明 str，初始值为 'hello'


            // setInterval(()=>{
            //     msgList.value.push({title:new Date()})
            // },1000)
            // console.log('ctx',ctx.$refs)
            const changeColor = () => {
                str.value = "改变了我的颜色";
                isRed.value = true;
                sessionStorage.setItem('token',new Date())
                token.value =  sessionStorage.getItem('token')

            };
            const changeStore = ()=>{
                console.log('ctx',ctx.$store.state);
                console.log('ctx',ctx.$store.commit);
                ctx.$store.commit('setTitle',new Date())

            };
            onMounted(() => {
                token.value =  sessionStorage.getItem('token')

                console.log('onMounted 页面挂在完成 stateDom1111', echart.value)
                initEchart(echart.value);
                initEchart1(echart1.value);
                initEchart2(echart2.value);
                initEchart3(echart3.value);
                window.onresize = function () {
                    console.log('浏览器窗口变动')
                }

            });
            const initEchart = (e)=>{
                console.log('initEchart')
                const option = {
                    title: {text: 'Line Chart'},
                    tooltip: {},
                    toolbox: {
                        feature: {
                            dataView: {},
                            saveAsImage: {
                                pixelRatio: 2
                            },
                            restore: {}
                        }
                    },
                    xAxis: {},
                    yAxis: {},
                    series: [{
                        type: 'line',
                        smooth: true,
                        data: [[12, 5], [24, 20], [36, 36], [48, 10], [60, 10], [72, 20]]
                    }],
                    dataZoom: [
                        {
                            show: true,
                            realtime: true,
                            start: 65,
                            end: 85
                        },
                        {
                            type: 'inside',
                            realtime: true,
                            start: 45,
                            end: 85
                        }
                    ],
                }
                const Chart = echarts.init(e);
                Chart.setOption(option);
            }
            const initEchart1 = (e)=>{
                console.log('initEchart')
                const option = {
                    xAxis: {
                        type: 'category',
                        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        data: [120, 200, 150, 80, 70, 110, 130],
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(220, 220, 220, 0.8)'
                        }
                    }],

                };
                const Chart = echarts.init(e);
                Chart.setOption(option);
            }
            const initEchart2 = (e)=>{
                console.log('initEchart')
                const option = {
                    backgroundColor: '#2c343c',

                    title: {
                        text: 'Customized Pie',
                        left: 'center',
                        top: 20,
                        textStyle: {
                            color: '#ccc'
                        }
                    },

                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },

                    visualMap: {
                        show: false,
                        min: 80,
                        max: 600,
                        inRange: {
                            colorLightness: [0, 1]
                        }
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '50%'],
                            data: [
                                {value: 335, name: '直接访问'},
                                {value: 310, name: '邮件营销'},
                                {value: 274, name: '联盟广告'},
                                {value: 235, name: '视频广告'},
                                {value: 400, name: '搜索引擎'}
                            ].sort(function (a, b) { return a.value - b.value; }),
                            roseType: 'radius',
                            label: {
                                color: 'rgba(255, 255, 255, 0.3)'
                            },
                            labelLine: {
                                lineStyle: {
                                    color: 'rgba(255, 255, 255, 0.3)'
                                },
                                smooth: 0.2,
                                length: 10,
                                length2: 20
                            },
                            itemStyle: {
                                color: '#c23531',
                                shadowBlur: 200,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },

                            animationType: 'scale',
                            animationEasing: 'elasticOut',
                            animationDelay: function (idx) {
                                return Math.random() * 200;
                            }
                        }
                    ],
                    dataZoom: [{
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 1,
                        borderColor:"#000",
                    },
                        {
                            type: 'slider', //slider表示有滑动块的
                            realtime: true,
                            start: 45, //数据窗口范围的起始百分比,表示1%
                            end: 85, //数据窗口范围的结束百分比,表示35%坐标
                        }
                    ]
                };
                const Chart = echarts.init(e);
                Chart.setOption(option);
            }
            const initEchart3 = (e)=>{
                console.log('initEchart')
                const option = {
                    title: {
                        text: '某站点用户访问来源',
                        subtext: '纯属虚构',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎']
                    },
                    series: [
                        {
                            name: '访问来源',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '60%'],
                            data: [
                                {value: 335, name: '直接访问'},
                                {value: 310, name: '邮件营销'},
                                {value: 234, name: '联盟广告'},
                                {value: 135, name: '视频广告'},
                                {value: 1548, name: '搜索引擎'}
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ],
                    dataZoom: [{
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 1,
                        borderColor:"#000",
                    },
                        {
                            type: 'slider', //slider表示有滑动块的
                            realtime: true,
                            start: 45, //数据窗口范围的起始百分比,表示1%
                            end: 85, //数据窗口范围的结束百分比,表示35%坐标
                        }
                    ]
                };

                const Chart = echarts.init(e);
                Chart.setOption(option);
            }

            return {
                str,
                changeColor,
                isRed,
                changeStore,
                echart,
                echart1,
                echart2,
                echart3,
                initEchart,
                msgList,
                token
            }
        }


    }
</script>

<style scoped>

    .isRed{
        color: red;
    }
    .chartBox
    {
        width: 300px;
        height: 300px;
        margin: 5px;
    }
</style>
